import { BUSCAR_HISTORICOS_RESERVAS, LIMPAR_HISTORICOS_RESERVAS } from '../../actions/types'

export default function reducerHistoricosReservas(state = [], action = undefined) {
  switch (action.type) {
    case BUSCAR_HISTORICOS_RESERVAS:
      return action.payload.data || []
    case LIMPAR_HISTORICOS_RESERVAS:
      return []
    default:
      return state
  }
}
